<template>
  <div id="page-wrapper">
    <div class="row">
      <div class="col-lg-12">
        <div class="col-lg-4 page__title_inventory">
          <h1 class="title__text">Инвентаризация</h1>
          <div v-if="tableIsVisible" class="title__buttons">
            <BarcodeButton v-if="mode === 'formatting'" />
            <OperationsButtons
              v-if="mode !== 'formatting'"
              class="buttons__group_operations"
            />
            <button
              v-if="operationsWereSaved"
              class="btn btn-primary buttons__button_to-stock"
              @click="$router.push('/stock_movement')"
            >
              <i class="fa fa-arrow-left fa-fw" />
              К движению по складу
            </button>
            <PrepareButton v-else class="buttons__button_prepare" />
          </div>
        </div>
      </div>
    </div>
    <Preloader v-if="isLoading" />
    <WithoutBarcodesNotice v-if="!isLoading && items.length < 1">
      <BarcodeButton />
    </WithoutBarcodesNotice>
    <ItemsTable v-if="tableIsVisible" />
  </div>
</template>

<script>
import Preloader from '@/_shared/components/ui/Preloader';
import WithoutBarcodesNotice from '@/stock/components/inventory/WithoutBarcodesNotice';
import ItemsTable from '@/stock/components/inventory/ItemsTable';
import BarcodeButton from '@/stock/features/inventory/BarcodeButton';
import PrepareButton from '@/stock/features/inventory/PrepareButton';
import OperationsButtons from '@/stock/features/inventory/OperationsButtons';
import store from "@/stock/store";
export default {
  components: {
    Preloader,
    WithoutBarcodesNotice,
    ItemsTable,
    BarcodeButton,
    PrepareButton,
    OperationsButtons,
  },
  computed: {
    tableIsVisible() {
      return !this.isLoading && this.items.length > 0;
    },
    operationsWereSaved() {
      const operations = store.state.inventory.confirmedOperations;
      return !!(operations.length > 0);
    },
    isLoading() {
      return store.state.inventory.isLoading;
    },
    items() {
      return store.state.inventory.items;
    },
    mode() {
      return store.state.inventory.mode;
    },
  },
  beforeDestroy() {
    store.dispatch('inventory/reset');
  },
};
</script>

<style scoped>
.page__title_inventory {
  margin: 1em 0;
}
.page__title_inventory,
.buttons__group_operations,
.title__buttons {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
}
.title__buttons,
.buttons__button_prepare,
.buttons__button_to-stock {
  margin-left: 1em;
}
.title__text {
  margin: 0;
}
@media (max-width: 1279px) {
  .page__title_inventory {
    width: 100%;
    justify-content: center;
    flex-direction: column;
  }
  .title__buttons {
    margin-top: 1em;
    margin-left: 0;
  }
}
@media (max-width: 1023px) {
  .title__buttons,
  .buttons__group_operations {
    flex-direction: column;
  }
  .buttons__button_prepare,
  .buttons__button_to-stock {
    margin-top: 1em;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/stock/pages/InventoryPage.vue